import React, { ReactNode } from 'react'

type InfoBlockOrderedListItemProps = { children?: ReactNode } & {
  [key: string]: unknown
}

export const InfoBlockOrderedListItem = ({ children, ...props }: InfoBlockOrderedListItemProps) => {
  return (
    <li
      className={`counter-increment before:bg-fill-primary
      flex
      gap-4
      before:h-6 before:w-6 before:shrink-0 before:rounded-[50%]
      before:text-center before:text-[16px] before:text-sm
      before:leading-6 before:content-[counter(counter)]
      `}
    >
      <span {...props}>{children}</span>
    </li>
  )
}
